export const CustomListBondsQuery = /* GraphQL */ `
  query GetAuthSession($id: ID = "test") {
    getUser(id: $id) {
      accounts {
        items {
          accountId
          createdAt
          account {
            balanceAccounts {
              items {
                id
                bondId
                currency
                transactions {
                  items {
                    balance
                    disponibleBalance
                    order
                  }
                }
              }
            }
          }
        }
      }
      id
      favoriteBonds
      createdAt
      updatedAt
    }
  }
`;
